<template>
  <dialog-modal-fi
    ref="productRetailerDialog"
    class="product-retailer-dialog-fite-fi"
    only-body-scrollable
    lazy
  >
    <template #header>
      <h2
        v-if="fields.retailerDialogHeadline?.value"
        class="product-retailer-dialog-fite-fi__headline"
      >
        {{ fields.retailerDialogHeadline.value }}
      </h2>
    </template>

    <template #body>
      <div class="product-retailer-dialog-fite-fi__retailers">
        <div
          v-for="retailer in retailers"
          :key="retailer.Name"
          class="product-retailer-dialog-fite-fi__retailer"
        >
          <div class="product-retailer-dialog-fite-fi__retailer__logo">
            <cloud-image-fi
              v-if="retailer.LogoUrl"
              :src="retailer.LogoUrl"
              :alt="retailer.Name"
              trim
              width="96"
              height="96"
              params="func=fit&bg_colour=FFF"
            />
          </div>
          <div class="product-retailer-dialog-fite-fi__retailer__data">
            <div class="product-retailer-dialog-fite-fi__retailer__name">
              {{ retailer.Name }}
            </div>
            <div class="product-retailer-dialog-fite-fi__retailer__link">
              <link-fi
                v-if="fields.retailerDialogShopLinkText?.value"
                :href="retailer.Url"
                :size="18"
                target="_blank"
                rel="noopener"
                primary
              >
                {{ fields.retailerDialogShopLinkText.value }}
              </link-fi>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template #footer>
      <div class="product-retailer-dialog-fite-fi__actions">
        <button-fi
          v-if="
            fields.retailerDialogRetailerSearchLink?.value?.href ||
            fields.retailerDialogRetailerSearchLink?.value?.url
          "
          :href="
            fields.retailerDialogRetailerSearchLink.value.href ||
            fields.retailerDialogRetailerSearchLink.value.url
          "
          :target="fields.retailerDialogRetailerSearchLink.value.target"
          class="button-fi__tertiary button-fi__xs-streched"
          natural-events
        >
          {{ fields.retailerDialogRetailerSearchLink.value.text }}
        </button-fi>
      </div>
    </template>
  </dialog-modal-fi>
</template>

<script>
import { ButtonFi, CloudImageFi, DialogModalFi, LinkFi } from 'atoms';

export default {
  name: 'ProductRetailerDialogFiteFi',
  components: {
    ButtonFi,
    CloudImageFi,
    DialogModalFi,
    LinkFi,
  },
  inject: ['fields'],
  props: {
    retailers: {
      type: Array,
      default: null,
    },
  },
  methods: {
    show() {
      this.$refs.productRetailerDialog.open();
    },
    close() {
      this.$refs.productRetailerDialog.close();
    },
  },
};
</script>

<style scoped src="./product-retailer-dialog-fite-fi" />
